import client from '../../shared/api/client';
import { KycLevel, KycStatus, KycVerification, PaginatedResponse } from '../../shared/types';

export interface KycListFilters {
  status?: KycStatus;
  level?: KycLevel;
  user_id?: number;
  per_page?: number;
}

export const listKyc = async (
  filters: KycListFilters = {}
): Promise<PaginatedResponse<KycVerification>> => {
  const response = await client.get<PaginatedResponse<KycVerification>>('/kyc', {
    params: filters,
  });
  return response.data;
};

export const getKyc = async (id: number): Promise<KycVerification> => {
  const response = await client.get<KycVerification>(`/kyc/${id}`);
  return response.data;
};

export const assignKyc = async (id: number): Promise<KycVerification> => {
  const response = await client.post<KycVerification>(`/kyc/${id}/assign`);
  return response.data;
};

export const approveKyc = async (
  id: number,
  internalNotes?: string
): Promise<KycVerification> => {
  const response = await client.post<KycVerification>(`/kyc/${id}/approve`, {
    internal_notes: internalNotes,
  });
  return response.data;
};

export const rejectKyc = async (
  id: number,
  reason: string,
  requestResubmit: boolean,
  internalNotes?: string
): Promise<KycVerification> => {
  const response = await client.post<KycVerification>(`/kyc/${id}/reject`, {
    reason,
    request_resubmit: requestResubmit,
    internal_notes: internalNotes,
  });
  return response.data;
};

export const getDocumentUrl = (path: string): string => {
  return `/api/kyc-documents/${path}`;
};
